import React from "react";
import { images } from "../../Images/Svg";
import { useNavigate } from "react-router-dom";
import style from "./CaseSearch.module.css";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TableGrid from "../../CommonComponents/TableGridView/TableGrid";
import { useSelector } from "react-redux";
import { Box } from "@mui/system";
import CommonButton from "../../CommonComponents/CommonButton";
import CommonModal from "../../CommonComponents/Modal/CommonModal";
import { useState } from "react";

const { backArrowBold, alert, rightArrow } = images;
const iconStyles = {
  width: "24px",
  height: "24px",
  fontWeight: "600",
  color: "#3A3A3A",
  margin: "0",
};
const caseSearchAccordion = {
  padding: "10px",
  borderRadius: "5px !important",
  background: "#FFF",
  boxShadow: "unset !important",
  border: "1px solid #004F99",
  marginTop: "0 !important",
  marginBottom: "0 !important",
  //   "& .MuiPaper-root": {
  //     "&:not(:first-of-type)": {
  //       borderTop: "1px solid #004F99 !important",
  //     },
  //   },
};
const policySearchAccordion = {
  padding: "10px",
  borderRadius: "5px !important",
  background: "#FFF",
  boxShadow: "unset !important",
  border: "1px solid #684E01",
  marginTop: "10px !important",
  marginBottom: "0 !important",
  //   "& .MuiPaper-root": {
  //     "&:not(:first-of-type)": {
  //       borderTop: "1px solid #684E01 !important",
  //     },
  //   },
};
const claimSearchAccordion = {
  padding: "10px",
  borderRadius: "5px !important",
  background: "#FFF",
  boxShadow: "unset !important",
  border: "1px solid #207A7A",
  marginTop: "10px !important",
  marginBottom: "0 !important",
  //   "& .MuiPaper-root": {
  //     "&:not(:first-of-type)": {
  //       borderTop: "1px solid #207A7A !important",
  //     },
  //   },
};
const accordionSummary = {
  minHeight: "0 !important",
  padding: 0,
  "& .MuiAccordionSummary-content": {
    margin: "0 !important",
  },
};
const accordionDetail = {
  padding: 0,
  marginTop: "6px",
  "& .MuiPaper-root": {
    padding: 0,
    "&:not(:first-of-type)": {
      //   borderTop: "1px solid #3A3A3A",
      borderRadius: 0,
      marginTop: "30px",
    },
  },
  "& .MuiPaper-root > .MuiGrid-container > .MuiGrid-item": {
    padding: "10px 10px 0 0",
  },
  "& .MuiPaper-root > .MuiGrid-container > .MuiGrid-item .highlight": {
    borderRadius: "5px",
    background: "rgba(58, 58, 58, 0.20)",
    boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.25)",
    padding: "2px 4px",
  },
};

const CaseSearch = () => {
  const [openViewMoreDetails, setOpenViewMoreDetails] = useState();
  const navigate = useNavigate();
  const onBackClick = (e) => {
    navigate(-1);
  };
  const caseSearchData = useSelector(
    (state) => state.SearchSlice.searchDetails
  );

  const onClickHandler = () => setOpenViewMoreDetails(true);

  return (
    <div className={style["case_search_Container"]}>
      <div className={style["case_search_header_container"]}>
        <img
          className={style["backArrow_Image"]}
          src={backArrowBold}
          alt="backArrow"
          onClick={onBackClick}
        />
        <h1 className={style["case_search_header"]}>Case Search</h1>
      </div>
      <div className={style["case_search_accordion_container"]}>
        <CommonModal
          open={openViewMoreDetails}
          showCrossIcon
          onClose={() => setOpenViewMoreDetails(false)}
        >
          <Typography sx={{ fontSize: "1.8rem", fontWeight: "bold" }}>
            Coming Soon
          </Typography>
        </CommonModal>
        {caseSearchData &&
        ((caseSearchData?.cases && caseSearchData?.cases?.length > 0) ||
          (caseSearchData?.policy && caseSearchData?.policy?.length > 0) ||
          (caseSearchData?.claim && caseSearchData?.claim?.length > 0)) ? (
          <>
            {caseSearchData?.cases && caseSearchData?.cases?.length > 0 && (
              <Accordion defaultExpanded={true} sx={caseSearchAccordion}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={iconStyles} />}
                  aria-controls="case-content"
                  id="case-header"
                  sx={accordionSummary}
                >
                  <span
                    style={{
                      backgroundColor: "#CCE6FF",
                      color: "#004F99",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      fontWeight: "400",
                    }}
                  >
                    Cases
                  </span>
                </AccordionSummary>
                <AccordionDetails sx={accordionDetail}>
                  {caseSearchData?.cases?.map((caseData, i) => (
                    <TableGrid
                      xs={3}
                      gridContent={caseData ? caseData : {}}
                      backgroundColor="#FFFFFF"
                      boxShadow="0px 0px 0px 0px"
                      padding="0"
                      isButton={false}
                      key={i}
                    />
                  ))}
                </AccordionDetails>
              </Accordion>
            )}
            {caseSearchData?.policy && caseSearchData?.policy?.length > 0 && (
              <Box sx={{ position: "relative" }}>
                <Accordion defaultExpanded={true} sx={policySearchAccordion}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={iconStyles} />}
                    aria-controls="policy-content"
                    id="policy-header"
                    sx={accordionSummary}
                  >
                    <span
                      style={{
                        backgroundColor: "#FFF2CD",
                        color: "#684E01",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                    >
                      Policy
                    </span>
                  </AccordionSummary>
                  <AccordionDetails sx={accordionDetail}>
                    {caseSearchData?.policy?.map((policydata, i) => {
                      return policydata?.case_id ? (
                        <>
                          <Box
                            sx={{
                              position: "absolute",
                              zIndex: 10,
                              left: "calc(50% - 89px)",
                              top: "9px",
                            }}
                          >
                            <CommonButton
                              label="View more details"
                              isEndIcon
                              filledButton
                              endIcon={
                                <img src={rightArrow} alt="right arrow" />
                              }
                              onClick={onClickHandler}
                            />
                          </Box>
                          <TableGrid
                            xs={3}
                            gridContent={policydata ? policydata : {}}
                            backgroundColor="#FFFFFF"
                            boxShadow="0px 0px 0px 0px"
                            padding="0"
                            key={i}
                          />
                        </>
                      ) : (
                        <TableGrid
                          xs={3}
                          gridContent={policydata ? policydata : {}}
                          backgroundColor="#FFFFFF"
                          boxShadow="0px 0px 0px 0px"
                          padding="0"
                          key={i}
                        />
                      );
                    })}
                  </AccordionDetails>
                </Accordion>
              </Box>
            )}
            {caseSearchData?.claim && caseSearchData?.claim?.length > 0 && (
              <Accordion defaultExpanded={true} sx={claimSearchAccordion}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={iconStyles} />}
                  aria-controls="claim-content"
                  id="claim-header"
                  sx={accordionSummary}
                >
                  <span
                    style={{
                      backgroundColor: "#D7F5F5",
                      color: "#207A7A",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      fontWeight: "400",
                    }}
                  >
                    Claim
                  </span>
                </AccordionSummary>
                <AccordionDetails sx={accordionDetail}>
                  {caseSearchData?.claim?.map((claimdata, i) => (
                    <TableGrid
                      xs={3}
                      gridContent={claimdata ? claimdata : {}}
                      backgroundColor="#FFFFFF"
                      boxShadow="0px 0px 0px 0px"
                      padding="0"
                      key={i}
                    />
                  ))}
                </AccordionDetails>
              </Accordion>
            )}
          </>
        ) : (
          <div className={style["case_not_found"]}>
            <img src={alert} alt="alert" />
            <p>No cases found!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CaseSearch;
